var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(21.000000, 17.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20604924,0 C9.65902699,-3.0680818e-05 10.0554359,0.304448101 10.1722536,0.742103757 C10.9299232,3.58070125 12.539172,5 15,5 C17.4608326,5 19.0700828,3.58069601 19.8277506,0.742088024 C19.9445855,0.304462534 20.3409727,8.32061244e-17 20.7939257,0 L25.3800883,0 C25.9323817,-1.56225374e-05 26.3801039,0.447706622 26.3801039,1 C26.3801039,1.03467777 26.3783001,1.06933207 26.3746998,1.10382244 C26.033979,4.3679036 26.0757457,6.66662945 26.5,8 C26.8654825,9.14865915 27.6508447,10.0084018 28.8560868,10.5792279 C29.5546251,10.9100799 30,11.6138201 30,12.3867488 L30,15 L21,15 L21,21 L30,21 L30,23 L21,23 L21,29 L30,29 L30,34 C24.6666667,36 19.6666667,37 15,37 C10.3333333,37 5.33333333,36 0,34 L0,29 L9,29 L9,23 L0,23 L0,21 L9,21 L9,15 L0,15 L0,12.739241 C1.24385047e-05,11.9014472 0.522190902,11.1524427 1.30828072,10.8626818 C2.27564933,10.5060996 3.00622243,9.55187237 3.5,8 C4.10812918,6.08873688 4.18497098,3.81189842 3.73052541,1.16948462 C3.636926,0.625193759 4.00227586,0.108076042 4.54656532,0.014468472 C4.60254899,0.00484033227 4.65925126,1.04350128e-17 4.71605682,0 L9.20604924,0 Z M7,25 L7,27 L0,27 L0,25 L7,25 Z M30,25 L30,27 L23,27 L23,25 L30,25 Z M7,17 L7,19 L0,19 L0,17 L7,17 Z M30,17 L30,19 L23,19 L23,17 L30,17 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.1ea5ad6a54eece6f814e7f15bddf7889.svg";
export { ForwardRef as ReactComponent };